import React, { useState, useEffect, useRef } from "react"
import {
  Col,
  Card,
  CardBody,
  Badge,
  Input,
  Label,
  Row,
  Button,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import { convertUtcToLocal, convertDateToUtc } from "../../helpers/util"
import { Link } from "react-router-dom"
import { isEmpty, map } from "lodash"
import { getRoles as onGetRoles,updateRole as onUpdateRole } from "../../store/roles/actions"
import PropTypes from "prop-types"
import { seasonPasstSatusTypes, messageTitle, stations } from "constants/common"
import RoleCreate from "./RoleCreate"
// import { updateRole as onUpdateRole } from "../../store/actions"
import DeleteModal from "components/Common/DeleteModal"
//redux
import { useSelector, useDispatch } from "react-redux"
const sizePerPage = 25

const getColor = status => {
  if (status == seasonPasstSatusTypes.Removed || status == seasonPasstSatusTypes.Rejected) {
    return "danger"
  } else if (
    status == seasonPasstSatusTypes.Approved ||
    status == seasonPasstSatusTypes.Available
  ) {
    return "success"
  } else if (status == "Not-Available") {
    return "dark"
  } else {
    return "warning"
  }
}

const checkStatus = status => {
  if (status == seasonPasstSatusTypes.Removed || status == seasonPasstSatusTypes.Rejected) {
    return true
  } else {
    return false
  }
}

const checkLiveStatus = status => {
  if (status == "Pending" || status == "Offline") {
    return false
  } else {
    return true
  }
}

const emptyDataMessage = () => {
  return <p style={{ textAlign: "center" }}>No data to display</p>
}

const RoleList = props => {
  //const { setSelectedRole, role } = props
  const dispatch = useDispatch()
  const [modal, setModal] = useState(false)
  const [selectedRole, setSelectedRole] = useState(null)
  const { roleList } = useSelector(state => ({
    roleList: state.roles.roleList,
  }))
  const [deleteModal, setDeleteModal] = useState(false)

  const pageOptions = {
    sizePerPage: sizePerPage,
    totalSize: roleList?.length || 1,
    custom: true,
  }
  const keyField = "_id"
  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  const roleListColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, record) => <>{record._id}</>,
    },
    {
      text: "ID",
      dataField: "roleId",
      sort: true,
    },
    {
      text: "Title",
      dataField: "roleTitle",
      sort: true,
    },
    {
      dataField: "roleType",
      text: "Visibility",
      sort: true,
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (cellContent, role) => (
        <Badge className={"bg-" + getColor(role?.status)}>
          {role?.status == "Approved" || role?.status == "Available"
            ? "Live"
            : role?.status}
        </Badge>
      ),
    },
    {
      dataField: "menu",
      isDummyField: true,
      editable: false,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, record) => (
        <div className="d-flex gap-3">
          <Link
            className="text-primary"
            to="#"
            style={{
              opacity: checkStatus(record?.status) ? "0.4" : 5,
              pointerEvents: checkStatus(record?.status) ? "none" : "auto",
            }}
          >
            <i
              className="mdi mdi-account-edit font-size-24"
              id="edittooltip"
              onClick={e => handleEditClick(record)}
              data-toggle="tooltip"
              data-placement="top"
              title="Update Role"
            ></i>
          </Link>
          <Link
            className={
              record?.status == "Not-Available" ? "text-success" : "text-black"
            }
            to="#"
            style={{
              opacity: checkStatus(record?.status) ? "0.4" : 5,
              pointerEvents: checkStatus(record?.status) ? "none" : "auto",
            }}
          >
            <i
              className={
                record?.status == "Not-Available"
                  ? "mdi mdi-account-arrow-left font-size-24"
                  : "mdi mdi-account-cancel font-size-24"
              }
              id="edittooltip"
              onClick={e => handleBlockClick(record)}
              data-toggle="tooltip"
              data-placement="top"
              title={
                record?.status == "Not-Available" ? "Live Role" : "Unlive Role"
              }
            ></i>
          </Link>
          <Link
            className="text-danger"
            to="#"
            style={{
              opacity: checkStatus(record?.status) || record?.count > 0 ? "0.4" : 5,
              pointerEvents: checkStatus(record?.status) || record?.count > 0 ? "none" : "auto",
            }}
          >
            <i
              className="mdi mdi-account-minus font-size-24"
              id="deletetooltip"
              onClick={() => onClickDelete(record)}
              data-toggle="tooltip"
              data-placement="top"
              title="Remove Role"
            ></i>
          </Link>
        </div>
      ),
    },
  ]

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  const onClickDelete = role => {
    setSelectedRole({ ...role, action: "Removed" })
    setDeleteModal(true)
  }

  const handleBlockClick = role => {
    if (role?.status == "Not-Available") {
      setSelectedRole({ ...role, action: "Available" })
    } else {
      setSelectedRole({ ...role, action: "Not-Available" })
    }
    setDeleteModal(true)
  }

  const handleLiveClick = role => {
    let status =
      role?.status == "Approved" || role?.status == "Available"
        ? "Pending"
        : "Approved"
    setSelectedRole({ ...role, action: status })
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    const updateRole = {
      id: selectedRole._id,
      status: selectedRole.action,
    }
    dispatch(onUpdateRole(updateRole))
    setDeleteModal(false)
  }

  useEffect(() => {
    dispatch(onGetRoles({countUsers:true}))
  }, [dispatch])

  const toggle = () => {
    console.log("modal", modal)
    setModal(!modal)
  }

  const handleEditClick = role => {
    setSelectedRole(role)
    console.log("first")
    setModal(true)
  }

  const handleAddClick = () => {
    setSelectedRole(null)
    console.log("second")
    setModal(true)
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        text={
          selectedRole?.action == "Not-Available"
            ? "Yes, unlive it!"
            : (selectedRole?.action == "Approved" || selectedRole?.action == "Available")
            ? "Yes, live it!"
            : selectedRole?.action == "Pending"
            ? "Yes, unlive it!"
            : "Yes, remove it!"
        }
        icon={
          selectedRole?.action == "Not-Available"
            ? "mdi mdi-account-cancel"
            : (selectedRole?.action == "Approved" || selectedRole?.action == "Available")
            ? "mdi mdi-account-arrow-left"
            : "mdi mdi-account-minus"
        }
        iconColor={
          selectedRole?.action == "Not-Available"
            ? "text-black"
            : (selectedRole?.action == "Approved" || selectedRole?.action == "Available")
            ? "text-success"
            : "text-danger"
        }
        bodyText={
          selectedRole?.action == "Not-Available"
            ? `Unlive the role: ${selectedRole?.roleTitle}`
            : (selectedRole?.action == "Approved" || selectedRole?.action == "Available")
            ? `Live the role: ${selectedRole?.roleTitle}`
            : selectedRole?.action == "Pending"
            ? `Unlive role: ${selectedRole?.roleTitle}`
            : `Remove role: ${selectedRole?.roleTitle}`
        }
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />

      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              {/* <PaginationProvider
                pagination={paginationFactory(pageOptions)}
                keyField={keyField}
                columns={roleListColumns}
                data={roleList || []}
              >
                {({ paginationProps, paginationTableProps }) => {
                  return ( */}
                    <ToolkitProvider
                      keyField={keyField}
                      data={roleList || []}
                      columns={roleListColumns}
                      bootstrap4
                      search
                    >
                      {toolkitProps => (
                        <React.Fragment>
                          <Row className="mb-2">
                            <Col sm="8"></Col>
                            <Col sm="4">
                              <div className="text-sm-end">
                                <Button
                                  color="primary"
                                  className="font-16 btn-block btn btn-primary"
                                  onClick={handleAddClick}
                                >
                                  <i className="mdi mdi-plus-circle-outline me-1" />
                                  Add New Role
                                </Button>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl="12">
                              <div className="table-responsive">
                                <BootstrapTable
                                  keyField={keyField}
                                  {...toolkitProps.baseProps}
                                  // {...paginationTableProps}
                                  defaultSorted={defaultSorted}
                                  classes={
                                    "table align-middle table-nowrap table-hover"
                                  }
                                  bordered={false}
                                  striped={false}
                                  responsive
                                  ref={node}
                                  noDataIndication={emptyDataMessage}
                                />
                              </div>
                            </Col>
                          </Row>
                          {/* <Row className="align-items-md-center mt-30">
                            <Col className="pagination pagination-rounded justify-content-end mb-2">
                              <PaginationListStandalone {...paginationProps} />
                            </Col>
                          </Row> */}
                        </React.Fragment>
                      )}
                    </ToolkitProvider>
              {/*     )
                }}
              </PaginationProvider> */}
            </CardBody>
          </Card>
        </Col>
      </Row>
      {console.log("modal ====>", modal)}
      {modal && (
        <RoleCreate
          isOpen={modal}
          toggle={() => toggle()}
          role={selectedRole}
          history={null}
          setSelectedRole={setSelectedRole}
        />
      )}
    </React.Fragment>
  )
}

export default RoleList
RoleList.propTypes = {
  setSelectedRole: PropTypes.func,
  role: PropTypes.object,
}
